<div #searchSuggestionsContainer class="flex flex-col">
    <div class="flex flex-row gap-2 justify-center align-middle">
        <svg class="w-6 h-6 fill-none stroke-faded-70" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" stroke-width="1.5">
            <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="searchSvgIcon" />
        </svg>
        <form [formGroup]="primarySearchFormGroup" (ngSubmit)="onSubmit()">
            <input 
                (focus)="onInputFocus()"
                #primarySearch
                formControlName="query"
                id="primary-search" 
                class="bg-transparent outline-none w-50 md:w-80 lg:w-[500px]" 
                type="text" 
                placeholder="Search for a card ..." 
                maxlength="1024"
                type="text"
                autocomplete="off">
        </form>
    </div>
    @if (shouldShow) {
        <div class="absolute w-max">
            <div class="flex flex-col absolute z-50 left-[30px] top-[30px] w-[244px] md:w-[324px] lg:w-[504px] max-h-[300px] overflow-y-auto bg-ponder text-slate-200 border border-faded-10 border-t-0 rounded-b card-shadow-light">
                @if (searchTerms && searchTerms.length > 0) {
                    @for (searchTerm of searchTerms ; track searchTerm.navigatesTo) {
                        <a href="{{ searchTerm.navigatesTo }}" class="flex flex-col gap-1 w-full p-1 hover:bg-ponder-linkhover hover:bg-opacity-15 cursor-pointer border-b border-faded-05 shadow-sm">
                            <div class="flex flex-row gap-2 sm:grow" [ngClass]="{ 'font-bold text-slate-50' : isExactMatch(searchTerm)}">
                                {{ searchTerm.term }}
                            </div>
                            <div class="text-faded-40 text-xs">
                                {{ getTermType(searchTerm) }}
                            </div>
                        </a>
                    }
                } @else {
                    <div class="p-1 text-faded-40 cursor-default">
                        No results found.
                    </div>
                }
            </div>
        </div>
    }
</div>